import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Mic = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M12 19v2m0-2c-3.678 0-5.853-2.255-6.986-4M12 19c3.678 0 5.853-2.255 6.986-4M16 7v4a4 4 0 0 1-8 0V7a4 4 0 0 1 8 0'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.25 7a4.75 4.75 0 1 1 9.5 0v4a4.75 4.75 0 1 1-9.5 0zm-2.644 7.37a.75.75 0 0 1 1.038.222C6.706 16.23 8.68 18.25 12 18.25s5.294-2.02 6.357-3.658a.75.75 0 0 1 1.258.816c-1.126 1.735-3.28 4.028-6.865 4.313V21a.75.75 0 1 1-1.5 0v-1.28c-3.584-.284-5.74-2.577-6.865-4.312a.75.75 0 0 1 .221-1.037'
        fill='currentColor'
      />
    )}
  </IconBase>
);
